import React, { useEffect, useState } from "react";
import BulletText from "../../components/contact/BulletText";
import ContactMenu from "../../components/contact/ContactMenu";
import PageBanner from "../../components/PageBanner";
import AboutUsService from "../../services/aboutUs";
import BannerService from "../../services/banner";
import { useParams } from "react-router-dom";

export default function ContactUs() {
  let [contactUsData, setContactUsData] = useState([]);
  let [contactUsBanner, setContactUsBanner] = useState([]);
  let { lang } = useParams();

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`${process.env.REACT_APP_WEB_URL}/th`, "_self");
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    getAboutUsData();
    getContactUsBanner();
    // eslint-disable-next-line
  }, []);

  const getAboutUsData = async () => {
    try {
      let res = await AboutUsService.getContact();
      setContactUsData(res);
    } catch {
      console.error();
    }
  };

  const getContactUsBanner = async () => {
    try {
      let res = await BannerService.getBanner(5);
      setContactUsBanner(res);
    } catch {
      console.error();
    }
  };

  function mapComponent(title, content) {
    return (
      <div>
        <h1 className="text-left text-[28px] xl:text-[32px] mt-[35px]">
          {title}
        </h1>
        <div
          className="contacts-map"
          dangerouslySetInnerHTML={{
            __html: lang === "th" ? content[0].detail_TH : content[0].detail_EN,
          }}
        />
      </div>
    );
  }

  function bulletComponent(title, content) {
    return (
      <div>
        <h1 className="text-left text-[28px] xl:text-[32px] mt-[35px]">
          {title}
        </h1>
        <BulletText
          text={lang === "th" ? content[0].detail_TH : content[0].detail_EN}
        />
      </div>
    );
  }

  function socialComponent(data) {
    return (
      <div className="flex justify-around mt-[25px]">
        {data &&
          data.map((item, i) => (
            <div
              key={i}
              className="w-full flex flex-col gap-[12px] justify-start items-center"
              onClick={() => {
                window.open(item.link, "_blank");
              }}
            >
              <div
                className="bg-lightGray border-lightGray rounded-full h-[96px] w-[96px] !bg-center !bg-cover"
                style={{
                  background: `url(${process.env.REACT_APP_API_URL}${item.image.data[0].attributes.url}), #D9D9D9`,
                }}
              />
              <h1 className="text-[18px] xl:text-[20px] text-center">
                {item.caption}
              </h1>
            </div>
          ))}
      </div>
    );
  }

  function subBulletComponent(title, content) {
    return (
      <div>
        <h1 className="text-left text-[28px] xl:text-[32px]">{title}</h1>

        {content &&
          content.map((data, i) => (
            <div key={i}>
              <p className="text-[20px] xl:text-[24px] text-left font-semibold mt-[15px] mb-[17px]">
                {lang === "th" ? data.subTitle_TH : data.subTitle_EN}
              </p>
              {data.content &&
                data.content.map((text, i) => (
                  <BulletText
                    key={i}
                    text={lang === "th" ? text.detail_TH : text.detail_EN}
                  />
                ))}
            </div>
          ))}
      </div>
    );
  }

  const bannerText = [{ name: "Contact us", href: "/contact-us" }];

  return (
    <div id="contact-us" className="pt-[135px] lg:pt-[0px]">
      <PageBanner
        text_th={"ติดต่อเรา"}
        text_en={"Contact us"}
        banner={contactUsBanner.banner}
        bannerText={bannerText}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          {/* ติดต่อเรา */}
          <div className="mt-[35px] mb-[134px]">
            <ContactMenu isOpen={3} lang={lang} />

            <div className="mt-[44px] grid grid-cols-1 xl:grid-cols-2 gap-[40px]">
              <div className="left-contact">
                {contactUsData &&
                  contactUsData
                    .filter((contact) => contact.leftSection === true)
                    .map((data, i) => (
                      <div key={i}>
                        {data.type === "map" &&
                          mapComponent(
                            lang === "th" ? data.title_th : data.title_en,
                            data.content
                          )}
                        {data.type === "email" &&
                          bulletComponent(
                            lang === "th" ? data.title_th : data.title_en,
                            data.content
                          )}
                        {data.type === "social" &&
                          socialComponent(data.content)}
                      </div>
                    ))}
              </div>

              <div className="right-contact">
                {contactUsData &&
                  contactUsData
                    .filter((contact) => contact.leftSection === false)
                    .map((data, i) => (
                      <div key={i}>
                        {data.type === "Locations" &&
                          subBulletComponent(
                            lang === "th" ? data.title_th : data.title_en,
                            data.content
                          )}
                      </div>
                    ))}
              </div>
            </div>

            {/* <div className="mt-[50px]">
              <h1 className="text-left text-[28px] xl:text-[32px]">
                แผนที่ปฎิบัติงาน
              </h1>
              <div className="border-[1px] border-lightGray2 rounded-[12px] h-[457px] w-full mt-[15px]" />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
